<template>
    <div>
        <!-- 面包屑导航区域 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>Equipment Mgmt</el-breadcrumb-item>
        <el-breadcrumb-item>Equipment Pay Log</el-breadcrumb-item>
      </el-breadcrumb>
        <!-- 卡片视图区域 -->
      <el-card>
      <!-- 搜索与添加区域 -->
        <collapse v-hasPermission="['equipment:select']" @getDataList="search">
      <collapse-item>
        <span>Device ID:</span>
        <el-input placeholder="Please input the Device ID" v-model.trim="queryInfoparams.params.uniqueCode" clearable></el-input>
      </collapse-item>
      <collapse-item>
          <span>Plumber Company:</span>
            <el-select v-model="queryInfoparams.params.companyId" filterable placeholder="" clearable @change="selectHandler">
              <el-option  v-for="item in companyList"
                :key="item.id"
                :label="item.companyName"
                :value="item.id">
              </el-option>
            </el-select>
      </collapse-item>
      <collapse-item v-if="this.state === '1'">
          <span>Agent:</span>
          <!-- <el-input placeholder="please input agant" v-model.trim="queryInfoparams.params.agencyName" clearable></el-input> -->
            <el-select v-model="queryInfoparams.params.agencyId" filterable placeholder="" clearable @change="selectHandler">
              <el-option  v-for="item in agencyList"
                :key="item.id"
                :label="item.agencyName"
                :value="item.id">
            </el-option>
          </el-select>
      </collapse-item>
      <collapse-item>
        <span class="demonstration">Settlement account date:</span>
        <el-date-picker v-model="startTime0" type="daterange" range-separator="to" start-placeholder="start Date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"   end-placeholder="end Date" @change="selectHandler"></el-date-picker> 
      </collapse-item>
    </collapse>
      <el-row type="flex" justify="end">
          <el-col class="searchBtns" :span="6">
              <el-button plain
                size="small" 
                @click="exportExcel"
                 icon="el-icon-download"
                v-hasPermission="['equipment:export']"
                 >Export
              </el-button>
         
          </el-col>
      </el-row>
        <!-- 设备缴费记录列表区域 -->
      <el-table type="selection" :data="equipmentPayLogList"  border stripe>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column  label="Device ID" sortable prop="uniqueCode"></el-table-column>
        <el-table-column label="Agent" sortable prop="agencyName"></el-table-column>
        <el-table-column label="Plumber company" sortable prop="companyName"></el-table-column>
        <el-table-column label="Plumber name" sortable prop="attribute2"></el-table-column>
        <el-table-column label="Settlement account date" sortable prop="cancellationDate"></el-table-column>
      </el-table>
    <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"

        @current-change="handleCurrentChange"

        :current-page="queryInfoparams.current"

        :page-sizes="[10, 50, 100, 200]"

        :page-size="queryInfoparams.size"

        layout="total, sizes, prev, pager, next, jumper"

        :total="total"
      ></el-pagination>
    </el-card> 
  </div>
</template>
<script>
  import db from '@/services/localstorage'
  import Collapse from '@/components/collapse/Collapse'
  import CollapseItem from '@/components/collapse/CollapseItem'
  export default {
    components:{
      Collapse,
      CollapseItem
    },
    data(){
      return{
        startTime0:'',
        queryInfoparams: {
        // 当前页码
        current: 0,// @ts-nocheck
        // 查询参数
        params: {
        },
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      user: {},
      state: '',
      // 设备列表
      equipmentPayLogList: [],
      agencyList: [],
      companyList: [],
      total: 0,
    }
  },
  methods: {
    selectHandler(){
      //将时间区间，分成两个参数传到后端
      if(this.startTime0 !== null){
        this.queryInfoparams.params.cancellationDate = this.startTime0[0]
        console.log( "startTime",this.queryInfoparams.params.startTime)
        this.queryInfoparams.params.cancellationDateTo = this.startTime0[1]
      }
      else{
        this.queryInfoparams.params.cancellationDate = null
        console.log( "startTime",this.queryInfoparams.params.cancellationDate)
        this.queryInfoparams.params.cancellationDateTo = null
      }
    },
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getEquipmentPayLogList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
     this.getEquipmentPayLogList()
    },
    //导出excel
    async exportExcel(){
      console.log('-----------')
      let res = this.$export('equipmentPayLog/exportExcel', JSON.stringify(this.queryInfoparams), 'agentPaymentRecord')
    },
    search(){
        this.queryInfoparams.current=0
         this.getEquipmentPayLogList()
    },
    // 获取缴费记录数据列表
    async getEquipmentPayLogList(data) {
      this.queryInfoparams.params.payType = "agency"
      this.user  = db.get("user");
      console.log("user",this.user)
      if (this.user.userType === "2") { 
        this.queryInfoparams.params.agencyId = this.user.companyId
      }
      this.$post('equipmentPayLog/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.equipmentPayLogList = res.records
          this.total = res.total
          console.log("设备计费记录",this.equipmentPayLogList,this.total)
        }
      )
    },
    //获取所有的水工公司
    getCompanyList() {
      this.user = db.get('user')
      this.$post('engineerCompany/queryEngineerCompanys', this.queryInfoparams).then(
        ({ data: res }) => {
          this.companyList = res
          console.log("水工公司",this.companyList)
        }
      )
    },
    //获取所有的代理商
    getAgencyList(){
      this.$post('agent/queryAgents', this.queryInfoparams).then(
        ({ data: res }) => {
          this.agencyList = res
          console.log("代理商",this.agencyList)
        }
      )
    },
  },
  created() {
    this.search()
    if(this.user.userType=='1'){
    this.getAgencyList()
    }
     if(this.user.userType!='3'){
    this.getCompanyList()
     }
  },
}
</script>
<style lang="less" scoped>

.collapse .left .collapse-item span
{
  color:#6A6767;
}

.el-select {
  width: 100%;
}
/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}
.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}
.el-row {
  flex: 1;
}
.el-tag {
  order: none !important;
}
.collapse {
  display: flex;
  justify-content: space-between;
}
</style>